import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetDashboardJobOpeningsQuery } from '../../../../utils/api_service/dashboardApi';
import { useDebouncedValue } from '../../hooks';
import { ADMIN_ROWS_PER_PAGE, ADMIN_SEARCH_DEBOUNCE_MS } from '../constants';
import { mapJobOpeningsToRows } from '../functions';
import type { IJobOpeningRow } from '../interfaces';
import type { JobOpeningData } from '../../../../utils/types/DashboardTypes';

export const useJobOpeningTab = (externalSearchTerm?: string) => {
  const history = useHistory();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const debouncedSearch = useDebouncedValue(externalSearchTerm ?? '', ADMIN_SEARCH_DEBOUNCE_MS);

  const { data, isLoading, isFetching } = useGetDashboardJobOpeningsQuery({
    search: debouncedSearch,
    page: pageNumber,
    limit: ADMIN_ROWS_PER_PAGE,
  });

  const openings: JobOpeningData[] = data?.jobOpenings ?? [];
  const totalRecords: number = data?.total ?? 0;
  const jobOpeningData: IJobOpeningRow[] = mapJobOpeningsToRows(openings);

  const totalPages = Math.max(1, Math.ceil(totalRecords / ADMIN_ROWS_PER_PAGE));

  const onPageChange = (page: number) => {
    setPageNumber(page);
  };

  const handleRowClick = (row: IJobOpeningRow) => {
    history.push(`/job-openings/${row.id}`);
  };

  return {
    searchTerm: externalSearchTerm,
    jobOpeningData,
    pageNumber,
    totalPages,
    loading: isLoading || isFetching,
    onPageChange,
    handleRowClick,
    history,
    totalRecords,
  };
};
